<template>
  <div class="shipping-address">
    <van-nav-bar title="收货地址" left-arrow @click-left="goBack" />

    <div v-if="!showForm" v-for="item in list" :key="item.id" class="form-box">
      <div class="form-item">
        <span class="label">收货人：</span>
        <span class="value">{{ item.name }}</span>
      </div>
      <div class="form-item">
        <span class="label">手机号：</span>
        <span class="value">{{ item.mobile }}</span>
      </div>
      <div class="form-item">
        <span class="label">所在地区：</span>
        <span class="value">{{ item.region }}</span>
      </div>
      <div class="form-item form-item--area">
        <span class="label">详细地址：</span>
        <span class="value value--left">{{ item.detail }}</span>
      </div>
      <van-button class="submit-btn" @click="editAddress(item)">
        修改地址
      </van-button>
    </div>

    <div v-if="showForm" class="form-box">
      <div class="form-item">
        <span class="label">收货人：</span>
        <input
          v-model.trim="form.name"
          type="text"
          placeholder="请输入收货人姓名"
          maxlength="20"
        />
      </div>
      <div class="form-item">
        <span class="label">手机号：</span>
        <input
          v-model.trim="form.mobile"
          type="tel"
          maxlength="11"
          @input="onPhoneInput"
          placeholder="请输入11位手机号"
        />
      </div>
      <div class="form-item">
        <span class="label">所在地区：</span>
        <input
          v-model.trim="form.region"
          type="text"
          placeholder="省 / 市 / 区"
        />
      </div>
      <div class="form-item form-item--area">
        <span class="label">详细地址：</span>
        <textarea
          v-model.trim="form.detail"
          rows="3"
          placeholder="请输入街道、门牌号等详细地址"
        ></textarea>
      </div>
      <van-button
        class="submit-btn"
        :loading="loading"
        :disabled="loading"
        @click="submit"
      >
        保存地址
      </van-button>
    </div>

  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "ShippingAddress",

  data() {
    return {
      loading: false,
      showForm: false,
      list: [],
      form: {
        name: "",
        mobile: "",
        region: "",
        detail: ""
      }
    };
  },

  mounted() {
    this.loadList();
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    unwrap(response) {
      if (response && response.code !== undefined) return response;
      return response && response.data ? response.data : response;
    },
    editAddress(item) {
      this.form = {
        name: item.name || "",
        mobile: item.mobile || "",
        region: item.region || "",
        detail: item.detail || ""
      };
      this.showForm = true;
    },
    resetForm() {
      this.form = {
        name: "",
        mobile: "",
        region: "",
        detail: ""
      };
    },
    onPhoneInput() {
      this.form.mobile = String(this.form.mobile || "")
        .replace(/\D/g, "")
        .slice(0, 11);
    },
    async loadList() {
      try {
        const res = await request.get("/api/v1/user/addressInfo");
        const result = this.unwrap(res);
        const data = result && result.data;
        const rows = Array.isArray(data) ? data : data ? [data] : [];
        this.list = rows.slice(0, 1);
        this.showForm = this.list.length === 0;
      } catch (e) {
        this.list = [];
        this.showForm = true;
      }
    },
    async submit() {
      if (!this.form.name) {
        this.$dialog.error("请输入收货人姓名");
        return;
      }
      if (!this.form.mobile) {
        this.$dialog.error("请输入手机号");
        return;
      }
      if (!/^1\d{10}$/.test(this.form.mobile)) {
        this.$dialog.error("请填写11位手机号码");
        return;
      }
      if (!this.form.region) {
        this.$dialog.error("请输入所在地区");
        return;
      }
      if (!this.form.detail) {
        this.$dialog.error("请输入详细地址");
        return;
      }
      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        const res = await request.post("/api/v1/user/addressSave", {
          name: this.form.name,
          mobile: this.form.mobile,
          region: this.form.region,
          detail: this.form.detail
        });
        this.loading = false;
        const result = this.unwrap(res);
        if (!result || result.code !== 200) {
          this.$dialog.error(
            result && result.msg ? result.msg : "提交失败，请稍后重试"
          );
          return;
        }
        this.$dialog.success("收货地址保存成功");
        this.resetForm();
        this.showForm = false;
        await this.loadList();
      } catch (e) {
        this.loading = false;
        const result =
          e && e.response && e.response.data ? e.response.data : null;
        this.$dialog.error(
          result && result.msg ? result.msg : "提交失败，请稍后重试"
        );
      }
    }
  }
};
</script>

<style scoped>
.shipping-address {
  min-height: 100vh;
  padding-bottom: 24px;
  background: linear-gradient(to bottom, #ff4b0b 0, #ff7a3d 90px, #fff7f0 250px);
  box-sizing: border-box;
}

.form-box {
  margin: 0 12px 12px;
  padding: 8px 16px 18px;
  background: #fff;
  border-radius: 9px;
}

.form-item {
  min-height: 52px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.form-item--area {
  align-items: flex-start;
  padding: 12px 0;
}

.form-item .label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #222;
}

.form-item .value {
  min-width: 0;
  flex: 1;
  padding: 0 8px;
  color: #333;
  font-size: 13px;
  text-align: right;
  word-break: break-all;
}

.form-item .value--left {
  text-align: left;
}

.form-item input,
.form-item textarea {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: none;
  text-align: right;
  font-size: 13px;
  color: #333;
  background: transparent;
  padding: 0 8px;
  box-sizing: border-box;
}

.form-item input {
  height: 52px;
}

.form-item textarea {
  text-align: left;
  resize: none;
  line-height: 1.5;
  padding: 4px 8px;
}

.form-item input::placeholder,
.form-item textarea::placeholder {
  color: #c5c5c5;
}

.submit-btn {
  width: 100%;
  height: 40px;
  margin-top: 14px;
  border: 0;
  border-radius: 22px;
  background: #ff4b0b;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.submit-btn--status {
  background: #ff8a5c;
}

.submit-btn--status.van-button--disabled {
  opacity: 1;
  color: #fff;
}
</style>
